import {styled} from '@esgi/ui/theme';
import {Drawer} from '@esgi/main/kits/common';

export const PanelContent = styled(Drawer.PanelContent, {
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	paddingTop: 40,
});